// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Lg4E","modalForm":"UpgradeEpcsModal_modalForm__2aYwV","modalFooter":"UpgradeEpcsModal_modalFooter__3Zc3I"};